import { Component, OnInit, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { NoticiaDetalhesPage } from '../noticia-detalhes/noticia-detalhes.page';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';

@Component({
  selector: 'app-list-titulo-resumo',
  templateUrl: './list-titulo-resumo.component.html',
  styleUrls: ['list-titulo-resumo.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ImagePipe
  ]
})
export class ListTituloResumoComponent {
  @Input()
  config: any;

  constructor(public modalCtrl: ModalController) { }

  getData() {
    return format(parseISO(this.config.date), 'dd/MM/yyyy');
  }

  async abrirNoticia() {
    const modalPage = await this.modalCtrl.create({
      component: NoticiaDetalhesPage,
      componentProps: {
        id: this.config.id,
      }
    });

    modalPage.present();
  }
}
